import api from './core';
import config from '../config';
import request from 'superagent';

/**
 * Async sleep function
 *
 * @param t {Number} Time to sleep in milliseconds
 */
function sleep(t) {
    return new Promise((resolve) => {
        setTimeout(() => resolve(), t);
    });
}

/**
 * Waiting for the background process of document checking/thumbnailification
 * to be completed.
 *
 * @param fileId {String} ID of the file to wait for
 */
async function waitUploadProcess(fileId) {
    const TIMEOUT = 10 * 60; // 10 minutes

    let success = false;
    let status;

    for (let i = 0; i < TIMEOUT && !success; i += 1) {
        await sleep(1000);

        status = await api.forwardResult(
            api.prepare(request.get(api.url(`/wupload/${fileId}/`))),
            'id',
        );

        const nonTerminal = (
            status.status === 'pending' ||
            status.status === 'processing'
        );

        if (!nonTerminal) {
            success = true;
        }
    }

    if (!success) {
        throw new Error('Erreur inconnue');
    }

    return status;
}

/**
 * Uploads a file using Wupload and waits for the process to complete.
 *
 * @param file {String} File object that you want to upload
 * @param progressCb {Function} Callback that will receive updates when the
 *                              upload will progress
 */
export function upload(file, progressCb) {
    return new Promise((resolve, reject) => {
        const url = config.API_URL + '/api/wupload/';
        const xhr = new XMLHttpRequest();
        const fd = new FormData();

        xhr.open('POST', url, true);

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                const out = {
                    status: xhr.status,
                    text: xhr.responseText,
                    json: undefined
                };

                try {
                    out.json = JSON.parse(out.text);
                } catch (e) {}

                if (xhr.status >= 200 && xhr.status < 300) {
                    waitUploadProcess(out.json.id).then(
                        (s) => resolve({out, ...{json: {
                            id: s.id,
                            content: s.file,
                            upload_date: s.date_create,
                            mime: s.mime_type,
                            preview: s.derivatives['g2_preview@2x'],
                            size: s.size
                        }}}),
                        () => reject(out),
                    );
                } else {
                    reject(out);
                }

            }
        };

        xhr.upload.addEventListener('progress', (e) => {
            if (e.lengthComputable) {
                progressCb(e.loaded / e.total);
            }
        });

        xhr.upload.addEventListener('load', () => {
            progressCb(1);
        });

        fd.append('file', file);
        fd.append('intent', 'document');
        fd.append('hint', JSON.stringify({function: 'none'}));

        xhr.setRequestHeader('Authorization', `Token ${api.getToken()}`);
        xhr.send(fd);
    });
}



// WEBPACK FOOTER //
// ./src/api/files.js